// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/Loader'

const InvoicesLoader = Loadable({
  loader: () => import('./InvoicesContainer'),
  loading: Loader,
})

export default InvoicesLoader
